// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1xNst","colMin":"styles_colMin__21uhp","colCheckbox":"styles_colCheckbox__1itVg"};